import { debounce, onKeyUpEscape } from '@theme/utilities'

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (e) => {
      if (e.target.classList.contains('mobile-facets__search-input')) return;
      this.debouncedOnSubmit(e);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.sortingOpenBtn = this.querySelector('.facets-containe__sorting-open');
    this.items = this.querySelectorAll('.facets-containe__sorting-item');
    this.selectSort = this.querySelector('#SortBy');

    this.openFiltersBtn = document.querySelector('.facets-container__open-filters');
    this.closeFiltersBtn = document.querySelector('.mobile-facets__close-button');
    this.applyFiltersBtn = document.querySelector('.mobile-facets__apply');
    this.filtersBg = document.querySelector('.facets-container__popup-bg');
    this.filtersPopup = document.querySelector('.mobile-facets__wrapper');

    this.searchInputStrain = document.querySelector('.mobile-facets__search-input');
    this.loadMoreBtn = document.querySelector('.js-load-more');


    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.debounceTimeout = null;

    this.header = document.querySelector('.header');
    this.facetsWrapper = document.querySelector('.facets-wrapper');
    this.facetsContainer = document.querySelector('.facets-container');
  }

  connectedCallback() {
    this.sortingOpenBtn?.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggleOpenSorting();
    });

    document.addEventListener("click", this.handleOutsideClick);

    this.openFiltersBtn?.addEventListener("click", () => this.toggleOpenFilters(true));
    this.closeFiltersBtn?.addEventListener("click", () => this.toggleOpenFilters(false));
    this.applyFiltersBtn?.addEventListener("click", () => this.toggleOpenFilters(false));
    this.filtersBg?.addEventListener("click", () => this.toggleOpenFilters(false));

    this.loadMoreBtn.addEventListener("click", () => FacetFiltersForm.showCards());

    this.addEventListener('input', (e) => {
      if (e.target.classList.contains('mobile-facets__search-input')) {
        this.handleSearchInput(e.target.value);
      }
    });

    this.addEventListener('click', (e) => {
      const item = e.target.closest('.facets-containe__sorting-item');
      if (!item) return;

      this.handleItemClick(item);
    });

    this.addEventListener('change', (e) => {
      if (e.target.matches('#SortBy')) {
        this.handleSelectChange();
      }
    });

    if (this.facetsWrapper || this.facetsContainer)  {
      this.updateFacetsHeight();
    }

    this.updateCount();
    FacetFiltersForm.applyFiltersFromURL();
    FacetFiltersForm.showCards();
    FacetFiltersForm.initLoadMoreObserver();

    this.checkFilterFixed();
    this.initFooterObserver();

    window.addEventListener('resize', () => {
      this.updateFacetsHeight();
      this.checkFilterFixed();
    });

    window.addEventListener('scroll', () => {
      this.checkFilterFixed();
    });
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleOutsideClick);
  }

  initFooterObserver() {
    const footer = document.querySelector('.shopify-section-group-footer-group');
    if (!footer) return;

    this.footerVisible = false;

    new IntersectionObserver(([entry]) => {
      this.footerVisible = entry.isIntersecting;
      this.checkFilterFixed();
    }, { threshold: 0 }).observe(footer);
  }

  checkFilterFixed() {
    const headerBlock = this.header.querySelector('.header__block');

    if (this.footerVisible) {
      headerBlock.classList.remove('has-filters');
      this.facetsContainer.classList.remove('m-fixed');
      this.facetsContainer.style.top = '';
      this.facetsContainer.style.left = '';
      return;
    }

    const scrollY = window.scrollY;
    const heightHeader = this.header.offsetHeight;
    const headerTop = window.innerWidth > 1000 ? 16 : 8;
    const top = heightHeader + headerTop - 2;
    const filterTop = this.facetsWrapper.getBoundingClientRect().top + window.scrollY;
    const trigger = filterTop - top;

    if(trigger < scrollY) {
      this.facetsContainer.classList.add('m-fixed');
      this.facetsContainer.style.top = `${top}px`;

      if (window.innerWidth > 1280) {
        this.facetsContainer.style.left = `${headerBlock.offsetLeft}px`;
      } else {
        this.facetsContainer.style.left = '';
      }
      headerBlock.classList.add('has-filters');
    } else {
      headerBlock.classList.remove('has-filters');
      this.facetsContainer.classList.remove('m-fixed');
      this.facetsContainer.style.top = '';
      this.facetsContainer.style.left = '';
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.applyFiltersFromURL();
        FacetFiltersForm.showCards();
        FacetFiltersForm.toggleLoadMoreButton(false);
        FacetFiltersForm.initLoadMoreObserver();
        document.querySelectorAll('facet-filters-form').forEach(form => {
          const searchInput = form.querySelector('.mobile-facets__search-input');
          form.updateCount();
          if(searchInput) {
            form.handleSearchInput(searchInput.value);
          }
        });
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.applyFiltersFromURL();
    FacetFiltersForm.showCards();
    FacetFiltersForm.toggleLoadMoreButton(false);
    FacetFiltersForm.initLoadMoreObserver();
    document.querySelectorAll('facet-filters-form').forEach(form => {
      const searchInput = form.querySelector('.mobile-facets__search-input');
      form.updateCount(); 
      if(searchInput) {
        form.handleSearchInput(searchInput.value);
      }
    });
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  handleOutsideClick = (e) => {
    const parent = this.sortingOpenBtn?.closest('.facets-containe__sorting');

    if (!parent?.contains(e.target)) {
      parent?.classList.remove('active');
    }
  };

  toggleOpenSorting() {
    const parent = this.sortingOpenBtn?.closest('.facets-containe__sorting');
    parent?.classList.toggle('active');
  }

  handleItemClick(clickedItem) {
    const selectSort = document.querySelector('#SortBy');
    const value = clickedItem.dataset.value;

    if (selectSort) {
      selectSort.value = value;
      selectSort.dispatchEvent(new Event('change', { bubbles: true }));
      selectSort.dispatchEvent(new Event('input', { bubbles: true }));
    }

    const items = document.querySelectorAll('.facets-containe__sorting-item');

    items.forEach(item => {
      item.classList.remove('active');
    });

    clickedItem.classList.add('active');

    const parent = this.sortingOpenBtn?.closest('.facets-containe__sorting');
    parent?.classList.remove('active');
  }

  handleSelectChange() {
    const value = this.selectSort.value;

    let matchedItem = null;
    this.items.forEach(item => {
      if (item.dataset.value === value) matchedItem = item;
      item.classList.remove('active');
    });

    if (matchedItem) matchedItem.classList.add('active');
  }

  toggleOpenFilters(open = false) {
    const filtersBg = this.filtersBg;
    const filtersPopup = this.filtersPopup;
    if(open) {
      filtersBg?.classList.add('m-show');
      filtersPopup?.classList.add('m-ready');
      filtersPopup?.classList.add('m-show');

      document.body.classList.add('overflow-hidden');
    } else {
      filtersPopup?.classList.remove('m-show');
      setTimeout(() => {
        filtersPopup?.classList.remove('m-ready');
        filtersBg?.classList.remove('m-show');

        document.body.classList.remove('overflow-hidden');
      },400);
    }
  }

  handleSearchInput(value) {
    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      const trimmedValue = value.trim();

      if (trimmedValue.length >= 3) {
        this.runSearch(trimmedValue);
      } else {
        this.resetSearch();
      }

    }, 500);
  }

  runSearch(query) {
    const searchValue = query.toLowerCase();
    const strainList = document.querySelectorAll('.mobile-facets__list-strain-type li');
    strainList.forEach(li => {
      const dataValue = (li.dataset.value || '').toLowerCase().trim();
      if (dataValue.includes(searchValue)) {
        li.classList.remove('m-hide');
      } else {
        li.classList.add('m-hide');
      }
    });
  }

  resetSearch() {
    const strainList = document.querySelectorAll('.mobile-facets__list-strain-type li');

    strainList.forEach(li => {
      li.classList.remove('m-hide');
    });
  }

  updateCount() {
    const filtersCount = document.querySelector('.mobile-facets__clear__count');
    const items = document.querySelectorAll('.mobile-facets__checkbox:checked');
    const count = items.length > 0 ? items.length : '';

    filtersCount.textContent = count;
  }

  static toggleLoadMoreButton(disabled) {
    const loadMoreBtn = document.querySelector('.js-load-more');
    if (!loadMoreBtn) return;

    loadMoreBtn.disabled = disabled;
    loadMoreBtn.classList.toggle('is-disabled', disabled);
  }

  static showCards() {
    const collection = document.querySelector('.main-collection');
    if (!collection) return;

    const dataGrid = Number(collection.dataset.grid);
    const cards = document.querySelectorAll('.main-collection__item:not(.m-show):not(.m-hidden)');

    cards.forEach((card, index) => {
      if (index < dataGrid) {
        card.classList.add('m-show');
      }
    });

    if (cards.length <= dataGrid) {
      FacetFiltersForm.toggleLoadMoreButton(true);
    }

  }

  static initLoadMoreObserver() {
    const loadMoreBtn = document.querySelector('.js-load-more');
    if (!loadMoreBtn) return;

    this.loadMoreObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        if (loadMoreBtn.disabled) return;

        const hiddenCards = document.querySelectorAll('.main-collection__item:not(.m-show)');

        if (hiddenCards.length === 0) return;

        this.loadMoreObserver.unobserve(loadMoreBtn);

        FacetFiltersForm.showCards();

        setTimeout(() => {
          const stillHidden = document.querySelectorAll('.main-collection__item:not(.m-show)');
          if (stillHidden.length > 0 && !loadMoreBtn.disabled) {
            this.loadMoreObserver.observe(loadMoreBtn);
          }
        }, 100);
      });
    }, {
      threshold: 0.3
    });

    this.loadMoreObserver.observe(loadMoreBtn);
  }

  static getActiveSearchParams() {
    return new URLSearchParams(window.location.search);
  }

  static hasActiveFilters() {
    const params = FacetFiltersForm.getActiveSearchParams();

    for (const [key] of params.entries()) {
      if (!key.toLowerCase().includes('sort')) {
        return true;
      }
    }

    return false;
  }

  static applyFiltersFromURL() {
    const collection = document.querySelector('.main-collection');
    if (!collection) return;

    const params = FacetFiltersForm.getActiveSearchParams();

    // Collect all filter.v.option.* params, case-insensitively
    // key: normalized option name (lowercase, spaces->hyphens)
    // value: array of allowed values (lowercase)
    const optionFilters = {};
    for (const [key, value] of params.entries()) {
      const match = key.match(/^filter\.v\.option\.(.+)$/i);
      if (!match) continue;
      const name = match[1].toLowerCase().replace(/[\s_]+/g, '-');
      if (optionFilters[name] == null) {
        optionFilters[name] = [];
      }
      optionFilters[name].push(value.toLowerCase());
    }

    const cards = document.querySelectorAll('.main-collection__item');

    cards.forEach(card => {
      const product = card.querySelector('.card-product');
      if (!product) return;

      // A card is hidden if it fails any of the option filters
      const hidden = Object.entries(optionFilters).some(([name, values]) => {
        const cardValue = (product.getAttribute(`data-option-${name}`) || '').toLowerCase();
        return !values.includes(cardValue);
      });

      card.classList.toggle('m-hidden', hidden);
    });
  }

  updateFacetsHeight() {
    const height = this.facetsContainer.offsetHeight;
    this.facetsWrapper.style.height = `${height}px`;
  }


}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
